import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Title, Body } from '@nerdwallet/react-typography';
import Link from '@nerdwallet/react-link';
import Image from '@nerdwallet/react-image';

import { stringInputSpec, titleInput } from '../../lib/editing-configs';

import styles from './featured-story.module.less';

const FeaturedStory = ({ title, body, linkUrl, previewImg }) => (
  <div className={styles.story__cont}>
    {previewImg ? (
      <Link href={linkUrl} target="_blank">
        <Image
          className={styles['story-image__cont']}
          src={previewImg}
          objectFit="cover"
          objectPosition="center"
          alt={title}
        >
          <div className={styles['story-image__overlay']} />
        </Image>
      </Link>
    ) : null}
    <div className={styles['story-body__cont']}>
      <Link href={linkUrl} color="neutral-darkest" target="_blank">
        <Title size="large" className={styles['story-title']}>
          {title}
        </Title>
      </Link>
      <Body>{body}</Body>
    </div>
  </div>
);

FeaturedStory.displayName = 'FeaturedStory';

FeaturedStory.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  linkUrl: PropTypes.string,
  previewImg: PropTypes.string,
};

FeaturedStory.defaultProps = {
  title: '',
  body: '',
  linkUrl: '',
  previewImg: '',
};

FeaturedStory.getEditingConfig = () => [
  titleInput,
  stringInputSpec('body', 'Preview body text'),
  stringInputSpec('linkUrl', 'URL of story'),
  stringInputSpec('previewImg', 'Preview image URL'),
];

export default FeaturedStory;
